import {AddImagePlaceHolder, CatalogItemImageCarousel, SidebarAlign, useCatalogItemSidebarDetailsStore, useVipLocalStore, VipLocalStore} from '@modules'
import {IImageOperationInput, StoresInstance} from '@stores'
import {_, React, classNames, withStyles, StyledProps, Fragment, Popover2, useAsObservableSource, observer, classObserver} from '@api'
import {ImageWrapperDefinition} from '@api/graphql'
import {Theme, Divider, Typography} from '@material-ui/core'
import {CatalogItemSidebarDetailsStore, utils} from '@modules'
import {action, observable, computed, autorun} from 'mobx'
import {IDisposer} from 'mobx-utils'
import {useEffect} from 'react'
import SwipeableViews from 'react-swipeable-views'
import {KeyboardArrowLeft, KeyboardArrowRight, MoreHoriz, Check} from '@material-ui/icons'
import {PrimaryIconButton, LazyLoadMedia, DropIndicator, Loading, DragEventPlaceholders, Placeholder, MyImage} from 'centric-ui-components'
import * as css from './SidebarCarousel.css'
import {Popover, Menu, MenuItem, Classes} from '@blueprintjs/core'
// import WrapperImageSlider from './ImageSlider/ImageSliderWrapper'

const styles = (theme: Theme) => ({
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    overflow: 'hidden',
    height: 300
  },
  img: {
    width: '100%',
    height: 300,
    overflow: 'hidden',
    objectFit: 'contain',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  dragArea: {
    height: 300,
    width: 300,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 109, 255, 0.3)'
  },
  media: {
    height: 300,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  },
  addIcon: {
    width: 48,
    height: 48,
    color: '#FFF'
  },
  caption: {
    textTransform: 'capitalize',
    color: 'rgba(27, 27, 27, 0.54)',
    fontSize: 14
  },
  emptyImage: {
    height: 300,
    backgroundColor: '#f5f5f5',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  photoIcon: {
    width: 50,
    height: 50,
    color: '#6d6d6d'
  },
  hide: {
    display: 'none'
  },
  uploadTextButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  uploadButtonCSS: {
    textTransform: 'capitalize',
    color: '#006dff',
    fontSize: '1.2rem',
    margin: 0,
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  uploadDisabled: {
    color: '#B1B1B1'
  },
  uploadDiv: {
    width: '175px',
    height: '36px',
    borderRadius: '2px',
    backgroundColor: '#4184f3',
    boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)'
  },
  uploadButton: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: '0.5px',
    color: '#ffffff'
  },
  uploadText: {
    fontSize: '14px',
    letterSpacing: '0.5px',
    color: '#ffffff'
  },
  uploadIcon: {
    width: '11px',
    height: '17px',
    backgroundColor: '#ffffff'
  },
  buttonProgress: {
    position: 'absolute',
    width: '56px',
    height: '56px',
    color: '#4184f3'
  },
  moreIcon: {
    color: '#FFF',
    height: 20,
    width: 20
  },
  avatarText: {
    backgroundImage: '#f5f5f5',
    color: 'rgba(27, 27, 27, 0.54)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 14
  },
  defaultImageText: {
    width: '100%',
    height: 20,
    fontSize: 14,
    lineHeight: 1.43,
    letterSpacing: 0.2,
    color: '#ffffff'
  },
  defaultTextDiv: {
    display: 'flex',
    flex: 1,
    margin: '0 24px',
    alignSelf: 'center'
  },
  successMessage: {
    backgroundColor: '#4caf50'
  },
  drag: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(65, 132, 243, 0.26)',
    borderRadius: 2,
    width: '100%',
    height: '100%'
  },
  loading: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFF',
    borderRadius: 2
  },
  add: {
    color: '#FFF',
    width: theme.spacing() * 10,
    height: theme.spacing() * 10,
    '& svg': {
      width: theme.spacing() * 6,
      height: theme.spacing() * 6
    },
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  placeholder: {
    width: 300,
    height: 300
  },
  hover: {
    backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.34))',
    height: 56,
    position: 'absolute',
    width: 300,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  hidden: {
    display: 'none'
  },
  cropFree: {
    marginRight: theme.spacing() * 3,
    color: '#FFF',
    width: 18,
    height: 18,
    cursor: 'pointer'
  },
  imageBottomPadding: {
    paddingBottom: '45px'
  },
  success: {
    width: '100%',
    position: 'absolute',
    top: 0,
    height: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0,
    transition: 'opacity 500ms ease-in-out',
    overflow: 'hidden'
  },
  show_success: {
    height: 300,
    opacity: 1,
    zIndex: 1
  },
  green_check: {
    backgroundColor: 'rgba(0, 128, 0, 0.75)',
    color: '#FFF',
    borderRadius: '50% 50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 36,
    height: 36
  }
})

interface ISidebarCarouselProps extends StyledProps {
  drag?: boolean
  loading?: boolean
  multiple?: boolean
  data: { id?: string, hex?: string, style?: any },
  localImages: Array<ImageWrapperDefinition>
  onClickUploadImages?: (e) => void
  onChangePlaceholderInput?: (e) => void,
  anchorEl?: HTMLElement,
  showDefault?: boolean
  openImageOptions?: (e) => void,
  inputRef?: (r) => void,
  isHex?: boolean,
  disableUpload?: boolean,
  success?: boolean
  skeleton?: boolean
  isPLM?: boolean
  imageDraggable?: boolean
  align: SidebarAlign
}

/// region Store

export class SidebarCarouselStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<ISidebarCarouselProps & {
    detailsStore: CatalogItemSidebarDetailsStore
  }, 'className'>) {
    super(stores)
  }

  /**
   * For parity with {@see CatalogItemCarouselStore}
   */
  @observable activeImageOperation: Partial<IImageOperationInput> = null

  registerEffects = () => {
    this.detailsStore._carouselStore = this

    const _toDispose: Array<IDisposer> = [
      autorun(() => {
        const {props: {localImages}} = this
        this.resetSelectedImageIndex()
      })
    ]

    return () => {
      _toDispose.forEach(d => {
        d()

        if (this.detailsStore?._carouselStore == this) {
          this.detailsStore._carouselStore = null
        }
      })
    }
  }

  file = React.createRef<HTMLInputElement>()
  inputRef = React.createRef<HTMLInputElement>()
  @observable selectedImageIndex = 0

  @action resetSelectedImageIndex = () => {
    const {props: {detailsStore: {localImages, sidebar: {selectedPathItem}}}} = this

    if (selectedPathItem?.imageId) {
      this.selectedImageIndex = localImages.findIndex(img => img.exId === selectedPathItem.imageId)
      if (this.selectedImageIndex === -1) {
        this.selectedImageIndex = 0
      }
    } else {
      this.selectedImageIndex = 0
    }
  }

  @computed get disableDeleteImage() {
    const {detailsStore: {catalog, imageSources}, localImages} = this.props,
      imageSource = imageSources.find(src => src.id === catalog?.workspaceConfig?._id || src.index === catalog.index)?.field ?? ''

    return localImages[this.selectedImageIndex]?.source != imageSource
  }

  @action onDeleteSelectedImage = async () => {
    const {detailsStore: {manageImage, isOffline}, selectedImage, selectedImageIndex, onChangeStep} = this
    await manageImage(isOffline ? selectedImageIndex : selectedImage?.exId, 'delete', selectedImage, () => {
      return selectedImageIndex && onChangeStep(selectedImageIndex - 1)
    })

  }

  @computed get canClickBackward() {
    return this.selectedImageIndex > 0
  }

  @computed get canClickForward() {
    const {selectedImageIndex, detailsStore: {localImages}} = this
    return selectedImageIndex + 1 < localImages.length
  }

  @action onClickForward = () => {
    if (this.canClickForward) {
      this.selectedImageIndex++
      this.props.detailsStore.updateActiveImageId(this.selectedImageIndex)
    }
  }

  @action onClickBackward = () => {
    if (this.canClickBackward) {
      this.selectedImageIndex--
      this.props.detailsStore.updateActiveImageId(this.selectedImageIndex)
    }
  }

  @action onChangeStep = activeStep => {
    this.selectedImageIndex = activeStep
  }

  @action onClickUploadImage = () => {
    const {file} = this
    file && file.current && file.current.click()
  }

  @action onAdd = (e: React.MouseEvent) => {
    e.stopPropagation()
    const {file: {current}} = this
    current && current.click()
  }

  get detailsStore() { return this.props.detailsStore}

  @computed get isImageSyncPending() {
    return this.selectedImage?.exId == null
  }

  @computed get selectedImage() {
    const {detailsStore: {localImages}, selectedImageIndex} = this
    return localImages[selectedImageIndex]
  }
}

export const SidebarCarouselStoreContext = React.createContext<SidebarCarouselStore>(null)
export const useSidebarCarouselStore = () => React.useContext(SidebarCarouselStoreContext)

/// endregion

/// region Components

export const SidebarCarouselInternal = observer<ISidebarCarouselProps>(function SidebarCarousel({className, ...props}) {
  const detailsStore = useCatalogItemSidebarDetailsStore(),
    obsProps = useAsObservableSource({...props, detailsStore}),
    store = useVipLocalStore((stores) => new SidebarCarouselStore(stores, obsProps)),
    {
      file, props: {
      inputRef, drag, data, loading, classes, localImages, disableUpload, style, success, skeleton, imageDraggable, align,
      detailsStore: {canAddImageOnData, addImages, catalog, onChangeFileUpload, onClickViewImage, onDownloadImage, index, onDragEnterImage, onDragLeaveImage, onDropImage, sidebar: {width: sidebarWidth}}
    },
      onClickBackward, onChangeStep, onClickForward, selectedImageIndex, onAdd, selectedImage, canClickBackward, canClickForward
    } = store,
    {dragDrop: {isDragging}, imageUrlFor} = catalog,
    actionButtons = catalog?.workspaceByIndex[index]?.catalog?.features?.actionButtons

  useEffect(() => store.registerEffects(), [])

  //const loading = this.props.loading || (data && data.loading)

  return (
    <SidebarCarouselStoreContext.Provider value={store}>
      <div className={classNames(css.container, className)}>
      <div
        // add generic drag function here to support the drop event.
        //data-drag-over={true/false} based on that we will show the placeholder for the component using css.
        key={`swipeable-${data.id}`}
        className={classNames(classes.container, css.root, skeleton && Classes.SKELETON)}
        data-show-drop-indicator={drag && isDragging}
        onDragEnter={!disableUpload ? onDragEnterImage : undefined}
        onDragOver={utils.eatMouseEvent}
        onDragLeave={!disableUpload ? onDragLeaveImage : undefined}
        onDrop={!disableUpload ? onDropImage : undefined}

        style={style}>
        <SidebarUploadFormInput/>

        {/* TODO: Based on editable roles will show DropIndicator */}
        <DropIndicator className={css.dropIndicator} classes={{dropIndicator: classes.placeholder}}/>
        <div className={classNames(classes.success, {[classes.show_success]: success})}>
          <div className={classes.green_check}>
            <Check/>
          </div>
        </div>

        {loading ? <Loading/> : localImages.length === 0 && data?.hex == null
                                ? <CatalogItemImageCarousel className={css.emptyCarousel} orientation='horizontal' align={align}/>
                                : catalog.canAddImage && canAddImageOnData && <AddImagePlaceHolder className={css.addImage} onChange={addImages}/>}

        {/* <DragEventPlaceholders dropType={dragDropEvents.def.dragType} id={dragDropEvents.def.id}  /> */}
        {localImages.length === 0 && !loading && data.hex &&
		 <div
			 style={{backgroundColor: data.hex}}/>}
        {localImages.length > 1 && !loading && selectedImageIndex > 0 && <PrimaryIconButton
			icon={<KeyboardArrowLeft/>}
			disabled={!canClickBackward}
			className={css.left}
			onClick={onClickBackward}
		/>}

        {localImages.length > 0 && !loading &&
		 <SwipeableViews
			 axis={'x'}
			 index={selectedImageIndex}
			 onChangeIndex={onChangeStep}
			 enableMouseEvents
			 className={classNames(css.swipeableViews)}
			 slideClassName={css.slide}
		 >
           {_.map(localImages, (image, i) => {
             if (image.hex && image.showHex) {
               return (<div
                   // {...dragDropEvents.events}
                   onDrop={!disableUpload ? onDropImage : undefined}
                   className={css.image}
                   data-type='SidebarCarouselImage'
                   style={{backgroundColor: image.hex, cursor: 'pointer'} as any}
                   onClick={onClickViewImage}
                 />
               )
             } else {
               const {source} = image,
                 imageUrl = imageUrlFor(image, {imageSize: {width: sidebarWidth, height: sidebarWidth}}),
                 fieldName = (source ?? '').replace('.images', ''),
                 field = fieldName ? catalog._fieldByName[fieldName] : undefined,
                 associatedWorkspace = field ? catalog.workspaceForField(field) : null,
                 sidebarObjectFit = associatedWorkspace ? associatedWorkspace.objectFit : catalog.objectFit

               // console.log({field, source, associatedWorkspace, sidebarObjectFit})
               return (
                 <div
                   key={`${image.exId}_${i}`}
                   data-type='SidebarCarouselImage'
                   // {...dragDropEvents.events}
                   onDrop={!disableUpload ? onDropImage : undefined}
                   onClick={onClickViewImage}
                   className={css.image}>
                   <MyImage
                     draggable={imageDraggable}
                     imageUrl={imageUrl}
                     imageId={image.exId}
                     objectFit={sidebarObjectFit}
                     //hex={hex}
                     //showHex={showHex}
                   />
                 </div>)
             }
           })}
		 </SwipeableViews>}
        {localImages.length > 1 && !loading && selectedImageIndex < (localImages.length - 1) && <PrimaryIconButton
			icon={<KeyboardArrowRight/>}
			disabled={!canClickForward}
			className={css.right}
			onClick={onClickForward}
		/>}
      </div>
      {localImages.length > 0 && (
        <div className={css.toolbar}>

          {/*    {false && !isHex && <div className={classes.defaultTextDiv}>*/}
          {/*<Typography className={classes.defaultImageText} variant={'subtitle1'}>*/}
          {/*          {selectedImageIndex === 0 ? `Default${isImageSyncPending ? ' (Sync Pending)' : ''}`*/}
          {/*                                    :*/}
          {/*           isImageSyncPending ? 'Sync Pending' : ''}*/}
          {/*</Typography></div>*/}
          {/*    }*/}

          {(!disableUpload) && (
            <div className={css.actions}>
              <Popover2
                position='bottom-right'
                interactionKind='hover'
                content={
                  <Menu>
                    {/* <MenuItem disabled={!styleExist || !activeImage || activeImage?.exId!==null} text="Sync Image To Style" onClick={()=>manageImage(activeImage?.id,'sync')}/> */}
                    <MenuItem disabled={!selectedImage} text='Download' onClick={(e) => onDownloadImage(e, selectedImage)}/>
                    {actionButtons && <Fragment>
					    <DeleteSidebarImageButton/>
					    <MenuItem disabled={false}
					              text={<span><label className={css.uploadLabel}>Upload New Image</label>
                    <input type='file' accept={'.jpg, .jpeg, .png'} multiple={true} ref={inputRef || file} style={{display: 'none'}}
                           onChange={onChangeFileUpload}/></span>} onClick={onAdd}/></Fragment>}
                  </Menu>
                }
              >
                <PrimaryIconButton aria-label='More' aria-haspopup='true' icon={<MoreHoriz classes={{root: classes.moreIcon}}/>}/>
              </Popover2>
            </div>)}
        </div>)}
    </div>
    </SidebarCarouselStoreContext.Provider>)
})
// @ts-ignore
export const SidebarCarousel: any = withStyles(styles as any)(SidebarCarouselInternal)

SidebarCarousel.defaultProps = {
  drag: false,
  loading: false,
  localImages: [],
  data: {},
  multiple: true,
  disableUpload: false,
  imageDraggable: false,
  align: 'left'
}

/// endregion

// export const SidebarCarousel = WrapperImageSlider(SidebarCarousel1)

export const SidebarUploadFormInput = observer(function SidebarUploadFormInput() {
  const store = useSidebarCarouselStore(),
    {props: {detailsStore: {onChangeFileUpload}, multiple, classes}, inputRef, file} = store

  return (<Fragment>
    <form encType='multipart/form-data'>
      <input
        type='file'
        ref={inputRef || file}
        onChange={onChangeFileUpload}
        className={classes.hide}
        accept='.jpg, .jpeg, .png'
        multiple={multiple}
      />
    </form>
  </Fragment>)
})

export const DeleteSidebarImageButton = observer(function DeleteSidebarImageButton() {
  const {selectedImage, disableDeleteImage, onDeleteSelectedImage, detailsStore: {isOffline}} = useSidebarCarouselStore()

  return (
    <MenuItem disabled={!selectedImage || disableDeleteImage || (!isOffline && _.isNull(selectedImage?.exId)) || (!isOffline && _.isUndefined(selectedImage?.exId))}
              text='Delete Image'
              onClick={onDeleteSelectedImage}
    />)
})


// WEBPACK FOOTER //
// ./src/shared/components/ui/widgets/SidebarCarousel.tsx